(function () {
  var ROOT_SELECTOR = '[data-bp-buy3-offer]';
  var MULTIPACK_SELECTOR = '[data-bp-multipack-offer]';
  var BOUGHT_TOGETHER_SELECTOR = '[data-bp-bought-together-offer]';
  var POPUP_OPEN_CLASS = 'bp-buy3-popup-open';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.moneyFormat || '${{amount}}');
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function getSelectedOption(select) {
    return select && select.options ? select.options[select.selectedIndex] : null;
  }

  function getOptionData(option) {
    return {
      id: option ? option.value : '',
      title: option ? option.dataset.title || option.textContent.trim() : '',
      price: option ? option.dataset.price || '' : '',
      priceCents: option ? parseInt(option.dataset.priceCents || '0', 10) : 0,
      image: option ? option.dataset.image || '' : '',
      eligible: option ? option.dataset.eligible === 'true' && !option.disabled : false,
    };
  }

  function setMessage(root, text, type, selector) {
    var message = root.querySelector(selector || '[data-bp-buy3-message]');
    if (!message) return;

    message.textContent = text || '';
    message.hidden = !text;
    message.classList.toggle('is-error', type === 'error');
    message.classList.toggle('is-success', type === 'success');
  }

  function syncPopup(popup) {
    var select = popup.querySelector('[data-bp-buy3-select]');
    var triggerLabel = popup.querySelector('[data-bp-buy3-trigger-label]');
    var selected = getOptionData(getSelectedOption(select));
    var row = popup.closest('[data-bp-buy3-row]');
    var rowImage = row ? row.querySelector('.bp-buy3-offer__item-image') : null;

    if (triggerLabel) {
      triggerLabel.textContent = selected.title;
    }

    if (rowImage && selected.image) {
      rowImage.src = selected.image;
      rowImage.srcset = '';
      rowImage.alt = selected.title;
    }

    popup.querySelectorAll('[data-bp-buy3-option]').forEach(function (button) {
      button.classList.toggle('is-selected', button.dataset.value === selected.id);
    });
  }

  function getOfferState(root) {
    var options = Array.prototype.map.call(root.querySelectorAll('[data-bp-buy3-select]'), function (select) {
      return getOptionData(getSelectedOption(select));
    });
    var eligibleOptions = options.filter(function (option) {
      return option.eligible && option.id;
    });
    var totalCents = eligibleOptions.reduce(function (sum, option) {
      return sum + option.priceCents;
    }, 0);
    var freeCents = eligibleOptions.reduce(function (lowest, option) {
      if (lowest === null) return option.priceCents;
      return Math.min(lowest, option.priceCents);
    }, null);

    return {
      options: eligibleOptions,
      totalCents: totalCents,
      freeCents: freeCents || 0,
      payableCents: Math.max(totalCents - (freeCents || 0), 0),
      ready: eligibleOptions.length === 4,
    };
  }

  function syncOffer(root) {
    root.querySelectorAll('[data-bp-buy3-popup]').forEach(syncPopup);

    var state = getOfferState(root);
    var price = root.querySelector('[data-bp-buy3-price]');
    var compare = root.querySelector('[data-bp-buy3-compare]');
    var saving = root.querySelector('[data-bp-buy3-saving]');
    var addButton = root.querySelector('[data-bp-buy3-add]');

    if (price) price.textContent = formatMoney(state.payableCents);
    if (compare) compare.textContent = formatMoney(state.totalCents);
    if (saving) saving.textContent = formatMoney(state.freeCents) + ' saved on the free item.';
    if (addButton) addButton.disabled = !state.ready;
  }

  function openPopup(popup) {
    var sheet = popup.querySelector('[data-bp-buy3-popup-sheet]');
    var trigger = popup.querySelector('[data-bp-buy3-popup-open]');
    if (!sheet) return;

    sheet.hidden = false;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add(POPUP_OPEN_CLASS);

    var selected = sheet.querySelector('[data-bp-buy3-option].is-selected');
    if (selected) selected.focus({ preventScroll: true });
  }

  function closePopup(popup) {
    var sheet = popup.querySelector('[data-bp-buy3-popup-sheet]');
    var trigger = popup.querySelector('[data-bp-buy3-popup-open]');
    if (!sheet) return;

    sheet.hidden = true;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus({ preventScroll: true });
    }

    if (!document.querySelector('[data-bp-buy3-popup-sheet]:not([hidden])')) {
      document.documentElement.classList.remove(POPUP_OPEN_CLASS);
    }
  }

  function selectPopupOption(root, popup, value, syncFn) {
    var select = popup.querySelector('[data-bp-buy3-select]');
    if (!select) return;

    select.value = value;
    (syncFn || syncOffer)(root);
    closePopup(popup);
  }

  function getGroupedItems(options) {
    return options.reduce(function (items, option) {
      var existing = items.find(function (item) {
        return item.id === Number(option.id);
      });

      if (existing) {
        existing.quantity += 1;
      } else {
        items.push({ id: Number(option.id), quantity: 1 });
      }

      return items;
    }, []);
  }

  function setLoading(button, isLoading) {
    if (!button) return;

    var spinner = button.querySelector('.loading-overlay__spinner');
    button.disabled = isLoading;
    button.classList.toggle('loading', isLoading);
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function getCartRootPath() {
    var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    if (rootPath.slice(-1) !== '/') rootPath += '/';
    return rootPath;
  }

  function redirectOfferToCheckout(root) {
    var button = root.querySelector('[data-bp-buy3-add]');
    var state = getOfferState(root);

    if (!state.ready) {
      setMessage(root, 'Choose four eligible items to use this offer.', 'error');
      return;
    }

    var items = getGroupedItems(state.options);
    var discountCode = (root.dataset.discountCode || '').trim();
    var permalinkItems = items.map(function (item) {
      return item.id + ':' + item.quantity;
    });
    var query = [];

    if (!permalinkItems.length) {
      setMessage(root, 'Choose four eligible items to use this offer.', 'error');
      return;
    }

    if (discountCode) {
      query.push('discount=' + encodeURIComponent(discountCode));
    }

    setLoading(button, true);
    setMessage(root, 'Redirecting to secure checkout...', 'success');

    window.location.href = getCartRootPath() + 'cart/' + permalinkItems.join(',') + (query.length ? '?' + query.join('&') : '');
  }

  function discountedPriceCents(totalCents, discountPercentage) {
    var discount = parseInt(discountPercentage || '0', 10) || 0;
    if (discount <= 0) return totalCents;
    return Math.max(Math.round(totalCents * (100 - discount) / 100), 0);
  }

  function getSelectedMultipackTier(root) {
    return root.querySelector('[data-bp-multipack-tier]:checked');
  }

  function getMultipackTierCard(tier) {
    return tier ? tier.closest('[data-bp-multipack-tier-card]') : null;
  }

  function getMultipackTierOptions(tier) {
    var tierCard = getMultipackTierCard(tier);
    if (!tierCard) return [];

    return Array.prototype.map.call(tierCard.querySelectorAll('[data-bp-buy3-select]'), function (select) {
      return getOptionData(getSelectedOption(select));
    }).filter(function (option) {
      return option.id;
    });
  }

  function getMultipackTierState(tier) {
    var options = getMultipackTierOptions(tier);
    var discountPercentage = parseInt(tier ? tier.dataset.discountPercentage || '0' : '0', 10) || 0;
    var regularCents = options.reduce(function (sum, option) {
      return sum + option.priceCents;
    }, 0);
    var priceCents = discountedPriceCents(regularCents, discountPercentage);
    var expectedQuantity = parseInt(tier ? tier.value || '0' : '0', 10) || 0;
    var ready = options.length === expectedQuantity && options.every(function (option) {
      return option.eligible;
    });

    return {
      tier: tier,
      options: options,
      regularCents: regularCents,
      priceCents: priceCents,
      compareCents: discountPercentage > 0 ? regularCents : 0,
      discountCode: tier ? (tier.dataset.discountCode || '').trim() : '',
      ready: ready,
    };
  }

  function syncMultipackOffer(root) {
    root.querySelectorAll('[data-bp-buy3-popup]').forEach(syncPopup);

    root.querySelectorAll('[data-bp-multipack-tier]').forEach(function (tier) {
      var tierState = getMultipackTierState(tier);
      var tierCard = getMultipackTierCard(tier);
      if (!tierCard) return;

      var price = tierCard.querySelector('[data-bp-multipack-tier-price]');
      var compare = tierCard.querySelector('[data-bp-multipack-tier-compare]');
      if (price) price.textContent = formatMoney(tierState.priceCents);
      if (compare) {
        compare.textContent = tierState.compareCents > tierState.priceCents ? formatMoney(tierState.compareCents) : '';
        compare.hidden = tierState.compareCents <= tierState.priceCents;
      }
    });

    var selectedState = getMultipackTierState(getSelectedMultipackTier(root));
    var addButton = root.querySelector('[data-bp-multipack-add]');
    if (addButton) addButton.disabled = !selectedState.ready;
  }

  function redirectMultipackToCheckout(root) {
    var button = root.querySelector('[data-bp-multipack-add]');
    var state = getMultipackTierState(getSelectedMultipackTier(root));

    if (!state.ready) {
      setMessage(root, 'Choose eligible items to use this pack.', 'error', '[data-bp-multipack-message]');
      return;
    }

    var items = getGroupedItems(state.options);
    var permalinkItems = items.map(function (item) {
      return item.id + ':' + item.quantity;
    });
    var query = [];

    if (!permalinkItems.length) {
      setMessage(root, 'Choose eligible items to use this pack.', 'error', '[data-bp-multipack-message]');
      return;
    }

    if (state.discountCode) {
      query.push('discount=' + encodeURIComponent(state.discountCode));
    }

    setLoading(button, true);
    setMessage(root, 'Redirecting to secure checkout...', 'success', '[data-bp-multipack-message]');
    window.location.href = getCartRootPath() + 'cart/' + permalinkItems.join(',') + (query.length ? '?' + query.join('&') : '');
  }

  function initMultipackOffer(root) {
    if (!root || root.dataset.bpMultipackInitialized === 'true') return;
    root.dataset.bpMultipackInitialized = 'true';

    root.addEventListener('click', function (event) {
      var popupOpen = event.target.closest('[data-bp-buy3-popup-open]');
      var popupClose = event.target.closest('[data-bp-buy3-popup-close]');
      var optionButton = event.target.closest('[data-bp-buy3-option]');
      var addButton = event.target.closest('[data-bp-multipack-add]');

      if (popupOpen && root.contains(popupOpen)) {
        event.preventDefault();
        openPopup(popupOpen.closest('[data-bp-buy3-popup]'));
        return;
      }

      if (popupClose && root.contains(popupClose)) {
        event.preventDefault();
        closePopup(popupClose.closest('[data-bp-buy3-popup]'));
        return;
      }

      if (optionButton && root.contains(optionButton)) {
        event.preventDefault();
        if (optionButton.disabled) return;
        selectPopupOption(root, optionButton.closest('[data-bp-buy3-popup]'), optionButton.dataset.value, syncMultipackOffer);
        return;
      }

      if (addButton && root.contains(addButton)) {
        event.preventDefault();
        redirectMultipackToCheckout(root);
      }
    });

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-bp-buy3-select], [data-bp-multipack-tier]')) {
        syncMultipackOffer(root);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      root.querySelectorAll('[data-bp-buy3-popup-sheet]:not([hidden])').forEach(function (sheet) {
        closePopup(sheet.closest('[data-bp-buy3-popup]'));
      });
    });

    syncMultipackOffer(root);
  }

  function getMainVariantInput() {
    return document.querySelector('form[action$="/cart/add"] input[name="id"].product-variant-id')
      || document.querySelector('form[action*="/cart/add"] input[name="id"]');
  }

  function getMainVariantId(root) {
    var input = getMainVariantInput();
    if (input) return Number(input.value);

    var fallback = root.querySelector('[data-main-variants-json]');
    if (!fallback) return 0;

    try {
      var variants = JSON.parse(fallback.textContent || '[]');
      return variants.length ? Number(variants[0].id) : 0;
    } catch (error) {
      return 0;
    }
  }

  function getMainVariantData(root) {
    var variantsJson = root.querySelector('[data-main-variants-json]');
    if (!variantsJson) return null;

    try {
      var variants = JSON.parse(variantsJson.textContent || '[]');
      var currentVariantId = getMainVariantId(root);
      return variants.find(function (variant) {
        return Number(variant.id) === currentVariantId;
      }) || variants[0] || null;
    } catch (error) {
      return null;
    }
  }

  function updateCartCount(count) {
    var selectors = [
      '#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]',
      '#cart-icon-bubble .cart-count-bubble',
      '.cart-count-bubble span[aria-hidden="true"]',
      '.cart-count-bubble',
      '[data-cart-count]',
      '.header__icon--cart .count',
      '.site-header__cart-count',
      '.cart-link__bubble',
      '.cart-count',
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.textContent = count;
      });
    });

    document.querySelectorAll('.cart-count-bubble, [data-cart-count], .site-header__cart-count, .cart-count, .cart-link__bubble').forEach(function (el) {
      if (count > 0) {
        el.removeAttribute('hidden');
        el.style.display = '';
      }
    });
  }

  function refreshCartUI() {
    return fetch(getCartRootPath() + 'cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        if (!cart) return;
        updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  function showBoughtTogetherMessage(card, text, type) {
    var message = card.querySelector('[data-message]');
    if (!message) return;

    message.hidden = !text;
    message.textContent = text || '';
    message.classList.toggle('is-error', type === 'error');
    message.classList.toggle('is-success', type === 'success');
  }

  function syncBoughtTogetherOffer(root) {
    var mainVariant = getMainVariantData(root);
    if (!mainVariant) return;

    var mainPrice = Number(mainVariant.price || 0);
    var mainCompare = Number(mainVariant.compare_at_price || 0);

    root.querySelectorAll('[data-bp-bought-card]').forEach(function (card) {
      var relatedPrice = Number(card.dataset.relatedPrice || 0);
      var relatedCompare = Number(card.dataset.relatedComparePrice || 0);
      var subtotal = mainPrice + relatedPrice;
      var saveAmount = Math.max(mainCompare - mainPrice, 0) + Math.max(relatedCompare - relatedPrice, 0);
      var compareTotal = subtotal + saveAmount;
      var mainPriceCard = card.querySelector('[data-main-price-card]');
      var subtotalEl = card.querySelector('[data-subtotal]');
      var compareEl = card.querySelector('[data-compare-total]');
      var badgeEl = card.querySelector('[data-save-badge]');

      if (mainPriceCard) mainPriceCard.textContent = formatMoney(mainPrice);
      if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);

      if (compareEl) {
        compareEl.textContent = saveAmount > 0 ? formatMoney(compareTotal) : '';
        compareEl.hidden = saveAmount <= 0;
      }

      if (badgeEl) {
        badgeEl.textContent = saveAmount > 0 ? 'Save ' + formatMoney(saveAmount) : '';
        badgeEl.hidden = saveAmount <= 0;
      }
    });
  }

  function setBoughtButtonLoading(button, isLoading) {
    setLoading(button, isLoading);
  }

  function addBoughtTogether(card) {
    var button = card.querySelector('[data-bp-bought-add]');
    var mainVariantId = getMainVariantId(card.closest(BOUGHT_TOGETHER_SELECTOR));
    var relatedVariantId = Number(card.dataset.relatedVariantId || 0);

    if (!mainVariantId || !relatedVariantId) {
      showBoughtTogetherMessage(card, 'Unable to add these items.', 'error');
      return;
    }

    setBoughtButtonLoading(button, true);
    showBoughtTogetherMessage(card, '', '');

    fetch(getCartRootPath() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          { id: mainVariantId, quantity: 1 },
          { id: relatedVariantId, quantity: 1 },
        ],
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add these items.');
        return refreshCartUI();
      })
      .then(function () {
        showBoughtTogetherMessage(card, 'Both items were added to your cart.', 'success');
      })
      .catch(function (error) {
        showBoughtTogetherMessage(card, error.message || 'Unable to add these items.', 'error');
      })
      .finally(function () {
        setBoughtButtonLoading(button, false);
      });
  }

  function initBoughtTogetherOffer(root) {
    if (!root || root.dataset.bpBoughtTogetherInitialized === 'true') return;
    root.dataset.bpBoughtTogetherInitialized = 'true';

    root.addEventListener('click', function (event) {
      var addButton = event.target.closest('[data-bp-bought-add]');
      if (!addButton || !root.contains(addButton)) return;

      event.preventDefault();
      addBoughtTogether(addButton.closest('[data-bp-bought-card]'));
    });

    document.addEventListener('change', function (event) {
      if (event.target && event.target.name === 'id') {
        window.setTimeout(function () {
          syncBoughtTogetherOffer(root);
        }, 50);
      }
    });

    syncBoughtTogetherOffer(root);
  }

  function initOffer(root) {
    if (!root || root.dataset.bpBuy3Initialized === 'true') return;
    root.dataset.bpBuy3Initialized = 'true';

    root.addEventListener('click', function (event) {
      var popupOpen = event.target.closest('[data-bp-buy3-popup-open]');
      var popupClose = event.target.closest('[data-bp-buy3-popup-close]');
      var optionButton = event.target.closest('[data-bp-buy3-option]');
      var addButton = event.target.closest('[data-bp-buy3-add]');

      if (popupOpen && root.contains(popupOpen)) {
        event.preventDefault();
        openPopup(popupOpen.closest('[data-bp-buy3-popup]'));
        return;
      }

      if (popupClose && root.contains(popupClose)) {
        event.preventDefault();
        closePopup(popupClose.closest('[data-bp-buy3-popup]'));
        return;
      }

      if (optionButton && root.contains(optionButton)) {
        event.preventDefault();
        if (optionButton.disabled) return;
        selectPopupOption(root, optionButton.closest('[data-bp-buy3-popup]'), optionButton.dataset.value);
        return;
      }

      if (addButton && root.contains(addButton)) {
        event.preventDefault();
        redirectOfferToCheckout(root);
      }
    });

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-bp-buy3-select]')) {
        syncOffer(root);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      root.querySelectorAll('[data-bp-buy3-popup-sheet]:not([hidden])').forEach(function (sheet) {
        closePopup(sheet.closest('[data-bp-buy3-popup]'));
      });
    });

    syncOffer(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(initOffer);
    (scope || document).querySelectorAll(MULTIPACK_SELECTOR).forEach(initMultipackOffer);
    (scope || document).querySelectorAll(BOUGHT_TOGETHER_SELECTOR).forEach(initBoughtTogetherOffer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
